import { IconButton, IIconProps, Persona, PersonaPresence, PersonaSize } from '@fluentui/react';
import { Flex, Label } from '@fluentui/react-northstar';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import * as React from 'react';
import defaultImage from '../../static/media/logo.png';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import styles from './index.module.scss';

const MeetingCard = ({
    meetingTitle,
    persona,
    imageInitials,
    duration,
    isAppAdded,
    fileCount,
    isSelected,
    meetingDuration,
    ...props
}: {
    meetingTitle: string;
    persona: string;
    imageInitials: string;
    duration: string;
    isAppAdded: boolean;
    fileCount: number;
    isSelected: boolean;
    meetingDuration: string;

    }) => {

    const {
        theme,
    } = useTypedSelector((state: ApplicationState) => state.meeting);

    const rightIcon: IIconProps = { iconName: 'ChevronRight' };

    return (
        <Flex className={[styles.root, styles["ms-teams-theme-" + theme]].join(' ')} >
            {isSelected && <Flex className={styles.selected} />}
            <Flex column={true} className={styles.fullWidth}>
                <Flex className={styles.meetingInfoContainer}>
                    <div className={styles.titleContainer}>
                        <TooltipHost content={meetingTitle}> <Label className={styles.meetingTitle}>{meetingTitle}</Label></TooltipHost>
                        <Label className={styles.duration}>{meetingDuration}</Label>
                    </div>
                    {isAppAdded && <Stack className={styles.appInfoContainer} horizontal={true}>
                        <img className={styles.appIcon} src={defaultImage} />
                        {fileCount > 0 && <Label className={styles.fileInfo}>{fileCount} Files</Label>}
                    </Stack>
                    }
                </Flex>
                <Stack className={styles.personaContainer}>
                    <Persona
                        imageInitials={imageInitials}
                        size={PersonaSize.size32}
                        presence={PersonaPresence.none}
                        hidePersonaDetails={true}
                        imageAlt=""
                    />
                    <Label className={styles.persona}>{persona}  {duration}</Label>
                </Stack>
            </Flex>
            {isSelected &&
                <Flex className={styles.chevron} vAlign={'center'} hAlign={'center'}>
                    <IconButton className={styles.chevron} disabled={true} iconProps={rightIcon} />
                </Flex>}
        </Flex>
    )
};

export default MeetingCard;
